import Rebase from 're-base'
import firebase from 'firebase'

const firebaseApp = firebase.initializeApp({
    apiKey: "AIzaSyDcVIaMn1njKDYxjHEN2kf_c56n2hsZNos",
    authDomain: "bolt-chews-wisely.firebaseapp.com",
    databaseURL: "https://bolt-chews-wisely.firebaseio.com",
    projectId: "bolt-chews-wisely",
    storageBucket: "bolt-chews-wisely.appspot.com",
    messagingSenderId: "917454034260",
    appId: "1:917454034260:web:d70e99c626cb26c3"
})

const base = Rebase.createClass(firebaseApp.database())

export { firebaseApp }

export default base